// Status page copy: docs/refresh/COPY_DECK.md "Status". The page is served
// at status.diligenshub.com (README "Status page"). Live states come from the
// app's GET /api/public/status (dataroom backend/routers/public_status_router.py),
// which returns component ids only; their names live here. Posted incidents
// live in ./statusIncidents.js.

export const seo = {
  title: 'DiligensHub Status',
  description:
    'Live status of DiligensHub data rooms, file transfers, document previews, AI review and email, with incident history.',
};

export const eyebrow = 'System status';

// Each component the page lists, in the endpoint's order. `live: true` takes
// the endpoint's state; a component with `live: false` would have no
// automated check and take its state from posted incidents alone. Every
// component is live today (FEATURE_SHOWCASE.md A-T1–A-T3).
export const components = [
  {
    id: 'core',
    name: 'Sign-in and data rooms',
    description: 'Signing in, opening rooms, and browsing and viewing files.',
    live: true,
  },
  {
    id: 'files',
    name: 'File uploads and downloads',
    description: 'Uploading files, and downloading originals, PDFs and archives.',
    live: true,
  },
  {
    id: 'previews',
    name: 'Document previews',
    description: 'Showing Word, Excel, PowerPoint and other files in the browser.',
    live: true,
  },
  {
    id: 'ai',
    name: 'AI document review',
    description: 'Checks on new uploads, Deal Signals and the AI Assistant.',
    live: true,
  },
  {
    id: 'email',
    name: 'Email notifications',
    description: 'Invitations, password resets and activity alerts.',
    live: true,
  },
];

// The overall heading (h1), by the worst state on the page.
export const overall = {
  checking: 'Checking Status…',
  operational: 'All Systems Operational',
  unknown: 'No Known Issues',
  maintenance: 'Maintenance in Progress',
  degraded: 'Some Systems Degraded',
  partial: 'Partial Outage',
  major: 'Major Outage',
  unreachable: "DiligensHub Isn't Responding",
};

export const sub = {
  checked: 'Checked at {time}. This page checks again every minute.',
  unreachable: "We couldn't reach DiligensHub at {time}. This page tries again every minute.",
  checking: 'Checking each part of DiligensHub now.',
};

// Component state labels (sentence case: they are pills, not titles).
export const states = {
  operational: 'Operational',
  degraded: 'Degraded performance',
  outage: 'Outage',
  maintenance: 'Under maintenance',
  unknown: 'Not checked recently',
  unreachable: 'No response',
  checking: 'Checking',
};

export const sections = {
  active: 'Current Incidents',
  scheduled: 'Scheduled Maintenance',
  components: 'Components',
  componentsNote: 'Each bar is one day. Its color shows the most serious incident posted that day.',
  history: 'Past Incidents',
  noIncidents: 'No incidents reported.',
  daysAgo: '{n} days ago',
  today: 'Today',
  noData: 'No records yet',
  barsNone: 'No incidents in the last {n} days',
  barsOne: '1 incident in the last {n} days',
  barsSome: '{count} incidents in the last {n} days',
};

// Incident and maintenance update stages, as each update is labeled.
export const stages = {
  investigating: 'Investigating',
  identified: 'Identified',
  monitoring: 'Monitoring',
  resolved: 'Resolved',
  scheduled: 'Scheduled',
  in_progress: 'In progress',
  completed: 'Completed',
};

export const impacts = {
  minor: 'Minor',
  major: 'Major',
  maintenance: 'Maintenance',
};

export const footer = {
  help: 'Need help?',
  support: 'Contact Support',
  site: 'diligenshub.com',
};
